import type { CSSProperties } from 'react';

/**
 * Visually-hidden polite live region (PRO-0250, NF-10). Announces the current
 * route title to assistive tech on navigation. Paired with `useRouteTitle`, which
 * also moves focus to the route heading.
 */
const visuallyHidden: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

export function RouteAnnouncer({ title }: { title: string }) {
  return (
    <div role="status" aria-live="polite" style={visuallyHidden}>
      {title}
    </div>
  );
}
